import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import NaturalCollection from './pages/NaturalCollection';
import ArtificialCollection from './pages/ArtificialCollection';
import ContactUs from './pages/ContactUs';
import CartPage from './pages/Cart';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 app-content" style={{ padding: '24px 0' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/natural" element={<NaturalCollection />} />
          <Route path="/artificial" element={<ArtificialCollection />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/cart" element={<CartPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}